import { render } from "./horizontal-sidebar.vue?vue&type=template&id=4b4693ca"
import script from "./horizontal-sidebar.vue?vue&type=script&lang=js"
export * from "./horizontal-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__